import Vue from 'vue'
import numeral from 'numeral'

Vue.filter('abbreviate', value => numeral(value).format('0.0a'))
Vue.filter('numeral', (value, format) => numeral(value).format(format))
Vue.filter('percentage', value => numeral(value).format('0.[00]%'))
Vue.filter('separator', value => numeral(value).format('0,0'))
Vue.filter('currency', value => numeral(value).format('$0,0.00'))
